<template>
  <div>
      <div v-if="Number.isNaN(averageEnergy)">
        No calories reported in last 30 days
      </div>
      <div v-else>
        <strong> {{ averageEnergy }} cal/per day </strong> in the last 30 days
      </div>
  </div>
</template>

<script>
import FoodAnalysis from '..'

export default {
    name: 'lifestyle-table-calorie-column',
    extends: FoodAnalysis
}
</script>

<style>

</style>